export const validationToastMessages = {
  UPLOAD_FILE: "Please upload a file",
  USER_PROMPT: "Please enter a user prompt",
  API_CALL_SUCCESS: "API call was successful",
  API_CALL_FAILURE: "API call failed",
};

export const analysisToastMessages = {
  UPDATE_SUCCESS: "Analysis details updated successfully",
  UPDATE_FAILURE: "Failed to update analysis details",
  FETCH_SUCCESS: "Analysis details fetched successfully",
  FETCH_FAILURE: "Failed to fetch analysis details",
  ANALYSIS_COMPLETED: "Analysis completed successfully",
  ANALYSIS_FAILED: "Analysis failed, please try again",
}